import { Row } from '@tanstack/react-table';
import { InternalIntegrationSetting } from 'models/InternalIntegrationSetting';
import { IntegrationCellWrapper } from './IntegrationCell.styles';
import IntegrationCellActions from './IntegrationCellActions';
import Badge from './badge';

const IntegrationCell = ({ row }: { row: Row<InternalIntegrationSetting> }) => {
  const { name, logo, displayName } = row.original.integration;
  const integrationName = displayName ?? name;

  return (
    <IntegrationCellWrapper>
      <img
        src={logo}
        alt={`${integrationName} logo`}
        width={48}
        height={48}
        loading="lazy"
      />

      <p>{integrationName}</p>

      <div className="badges">
        {row.original.integration.badges.map((badge) => (
          <Badge key={badge} type={badge} />
        ))}
      </div>

      <div className="actions">
        <IntegrationCellActions integrationSetting={row.original} />
      </div>
    </IntegrationCellWrapper>
  );
};

export default IntegrationCell;
